import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, H1, Text } from '@betterment/samba-react';

import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';

import { TaskListDocument } from './graphql/query.taskList.generated';
import womanLiftingTasks from './images/woman_lifting_tasks.svg';
import { TaskList } from './task-list/TaskList';

import { ApplicationLayout } from '../layout/ApplicationLayout';

export const TasksPage = () => {
  const employerId = useCurrentEmployerId();
  const { data, dataState } = useGraphQLQuery(TaskListDocument, {
    variables: { employerId },
  });

  return (
    <ApplicationLayout pageTitle="Tasks">
      <ApplicationLayout.Header>
        <Box css={{ maxWidth: '760px', mx: 'auto', width: '100%' }}>
          <H1 variant="title300">Tasks</H1>
        </Box>
      </ApplicationLayout.Header>

      <ApplicationLayout.Content>
        {dataState === 'complete' && (
          <Card
            css={{
              maxWidth: '760px',
              mx: 'auto',
              py: 'space.100',
            }}
          >
            {data.employer.tasks.items.length === 0 ? (
              <Box
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  p: 'space.300',
                }}
              >
                <img src={womanLiftingTasks} alt="" />
                <Text css={{ marginTop: 'space.400' }}>You're all caught up!</Text>
              </Box>
            ) : (
              <TaskList tasks={data.employer.tasks.items} />
            )}
          </Card>
        )}
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
